/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Reality_CzInputs */

const cs_enum_reality_cz = /** @type {(inputs: Enum_Reality_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality.cz`)
};

const en_enum_reality_cz = /** @type {(inputs: Enum_Reality_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reality.cz`)
};

/**
* | output |
* | --- |
* | "Reality.cz" |
*
* @param {Enum_Reality_CzInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reality_cz = /** @type {((inputs?: Enum_Reality_CzInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Reality_CzInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reality_cz(inputs)
	return cs_enum_reality_cz(inputs)
});